import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, Observable, of} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ResetPasswordRequest} from '../models/resetPasswordRequeste';
import {credentialHttpOptionsJson, defaultHttpOptionsJson} from '../http.options';

@Injectable({
    providedIn: 'root',
})
export class AuthService {

    private publicApiUrl = environment.apiAuthUrl + '/public';

    constructor(private http: HttpClient) {}

    checkToken(): Observable<any> {
        return this.http.post(
            this.publicApiUrl + '/checkToken',
            {},
            credentialHttpOptionsJson
        )
    }

    refreshToken(): Observable<any> {
        return this.http.post(
            this.publicApiUrl + '/refresh',
            {},
            credentialHttpOptionsJson
        )
    }

    login(username: string, password: string): Observable<any> {
        return this.http.post(
          this.publicApiUrl + '/loginWEB',
            {
                username,
                password,
            },
            credentialHttpOptionsJson
        )
    }

    register(username: string, email: string, password: string): Observable<any> {
        return this.http.post(
            this.publicApiUrl + '/signup',
            {
                username,
                email,
                password,
            },
            defaultHttpOptionsJson
        );
    }

    logout(): Observable<any> {
        return this.http.post(environment.apiAuthUrl + 'logout', {}, credentialHttpOptionsJson);
    }

    resetPassword(sendPsw: ResetPasswordRequest) {
        return this.http.post<any>(environment.apiAuthUrl + '/public/reset-password', sendPsw, defaultHttpOptionsJson)
            .pipe(catchError((err) => {
                console.error('Error sending password reset request', err);
                return of(null);
            })
        )
    }
}
